import Vue from "vue";

Vue.component("country-eping-administrator", {
	props: ["notificationId", "loadingText"],
	data() {
		return {
			loading: false,
			hasEpingAdmin: false,
			domainId: null,
			countryName: null,
		};
	},
	computed: {
		titleWithEPingAdmin() {
			return window.labels.withEPingAdmin.replace('{0}', this.countryName);
		},
		titleWithoutEPingAdmin() {
			return window.labels.withoutEPingAdmin.replace('{0}', this.countryName);
		},
		withEPingAdmin() {
			return window.labels.withEPingAdmin;
		},
		withoutEPingAdmin() {
			return window.labels.withoutEPingAdmin;
		},
	},
	methods: {
		checkCountryHasEpingAdmin: function () {
			this.loading = true;
			this.$services.users.countryHasEPingAdmin({
				notificationId: this.notificationId,
				language: window.currentOfficialLanguageInt
			})
				.then((data) => {
					this.loading = false;
					this.hasEpingAdmin = data.hasEPingAdmin;
					this.domainId = data.domain;
					this.countryName = data.countryName;
				});
		}
	},
	mounted: function () {
		this.checkCountryHasEpingAdmin();
	},
	template: `
      <div v-if="loading">
	  	<loading :loading-text="loadingText"></loading>
	  </div>
	  <div v-else class="admin-registered-container">
		  <div style="position: relative">
			<div v-if="hasEpingAdmin" class="eping-admin-icon filled" :title="titleWithEPingAdmin"></div>
			<div v-else class="eping-admin-icon" :title="titleWithoutEPingAdmin"></div>
			<div v-if="hasEpingAdmin" class="admin-registered" :title="titleWithEPingAdmin">
			  <span>{{ titleWithEPingAdmin }}</span>
			</div>
			<div v-else class="admin-registered" :title="titleWithoutEPingAdmin">
			  <span>{{ titleWithoutEPingAdmin }}</span>
			</div>
		  </div>
      </div>
	`
});